import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { login } from "../../redux/actions/adminActions";
import Loader from "../../components/Loader/Loader";
import Hero from "../../assets/images/ist.svg";
import "./login.scss";

const Login = () => {
  const [fields, setFields] = useState({
    email: "",
    password: "",
  });
  const [validation, setValidation] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPassowrd, setShowPassWord] = useState();

  const dispatch = useDispatch();
  const adminLogin = useSelector((state) => state.adminLogin);
  const navitage = useNavigate();

  const useAuth = () => {
    const user = localStorage.getItem("accessToken");
    if (user) {
      return true;
    } else {
      return false;
    }
  };
  const user = useAuth();

  useEffect(() => {
    if (adminLogin) {
      if (adminLogin?.loading !== undefined) {
        setLoading(adminLogin?.loading);
      }
    }
  }, [adminLogin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValidation({ ...validation, [name]: checkValidation(name, value) });
    setFields({ ...fields, [name]: value });
  };

  const checkValidation = (name, value) => {
    switch (name) {
      case "email":
        if (!value) {
          return "Email is required";
        } else if (
          !value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)
        ) {
          return "Enter a valid email address";
        } else {
          return "";
        }
      case "password":
        if (!value || value.trim() === "") {
          return "Password is required";
        } else {
          return "";
        }
      default: {
        return "";
      }
    }
  };

  const handleShowPassword = () => {
    setShowPassWord(!showPassowrd);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    let validationErrors = {};
    let field = fields;
    
    Object.keys(field).forEach((name) => {
      const error = checkValidation(name, field[name]);
      if (error && error.length > 0) {
        validationErrors[name] = error;
      }
    });
    if (Object.keys(validationErrors).length > 0) {
      setValidation(validationErrors);
      return;
    }

    if (fields.email && fields.password) {
      dispatch(login(fields.email, fields.password, navitage));
    }
  };

  return (
    <>
      <Loader isLoading={loading} />
      {!user && (
        <div className="main-login">
          <div className="login-contain">
            <div className="right-side ">
              <img
                src={Hero}
                id="wel-img-id"
                style={{ alignSelf: "center" }}
                alt=""
              />
            </div>
            <div className="left-side">
              <form onSubmit={handleLogin}>
                <div className="welcomeNote">
                  <h3 className="login-main">MOAT</h3>
                </div>

                <label className="lable" htmlFor="email">
                  Email
                  <input
                    type="email"
                    className="emailone"
                    placeholder="Enter your email..."
                    name="email"
                    onChange={handleChange}
                    value={fields.email}
                  />
                  {validation.email && (
                    <p style={{ color: "red" }}>{validation.email}</p>
                  )}
                </label>

                <label className="lable" style={{ position: "relative" }}>
                  Password
                  <input
                    type={showPassowrd ? "text" : "password"}
                    className="emailone"
                    placeholder="password"
                    name="password"
                    onChange={handleChange}
                    value={fields.password}
                  />
                  {showPassowrd ? (
                    <BsFillEyeFill
                      className="eyeIcon"
                      onClick={handleShowPassword}
                    />
                  ) : (
                    <BsFillEyeSlashFill
                      className="eyeIcon"
                      onClick={handleShowPassword}
                    />
                  )}
                  {validation.email && (
                    <p style={{ color: "red" }}>{validation.password}</p>
                  )}
                </label>

                <button type="submit" className="sub">
                  SUBMIT
                </button>
              </form>

              
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
